<template>
  <div class="accept-time-wrapper">
    <h5>{{ isHotel ? $t("waiting.title_hotel") : $t("waiting.title") }}:</h5>
    <div class="accept-time-buttons">
      <div
        :class="getButtonClass(time)"
        @click="setTime(time)"
        v-for="time in times"
        :key="time"
      >{{ time }} {{ $t("waiting.time") }}</div>
    </div>
    <input
      class="accept-time-input"
      type="number"
      :value="value"
      @input="onInput"
      :placeholder="$t('waiting.exact_time')"
      max="3600"
    />
  </div>
</template>

<script>
export default {
  props: {
    times: Array,
    value: Number,
  },
  methods: {
    getButtonClass(time) {
      return {
        "accept-time-button": true,
        "accept-time-button-active": time == this.value,
      };
    },
    setTime(time) {
      this.$emit("input", +time);
    },
    onInput(ev) {
      this.setTime(+ev.target.value);
    },
  },
  computed: {
    isHotel() {
      return this.$store.getters.isHotel;
    }
  }
};
</script>

<style scoped>

h5 {
  margin: 0;
}

.accept-time-wrapper {
  padding-left: 5vw;
  padding-right: 5vw;

  color: #908f8d;
}

.accept-time-buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 2vh;
}

.accept-time-button {
  color: #1d1d1b;
  border: 2px solid #129b81;
  padding: 1.5vh 2.5vh;
  border-radius: 5vh;
  text-align: center;
  width: fit-content
}

.accept-time-button-active {
  background: #129b81;
  color: #ededed;
  transition: 0.3s;
}

.accept-time-input {
  margin-top: 1.9vh;
  outline: none;
  border: 2px solid #129b81;
  border-radius: 10vw;
  width: 100%;
  background: transparent;

  padding: 1.4vh;
  text-align: center;
  text-align-last: center;

  -webkit-appearance: none;
}
@media (min-width: 768px) {
  .accept-time-wrapper {
    padding: 0 1.389vw 0;
    margin: 0;
  }
  .accept-time-wrapper h5 {
    font-size: 1.25vw;
    padding-top: 1vw;
    line-height: 1.458vw;
  }
  .accept-time-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30%;
    height: 3.472vw;
    font-size: 1.111vw;
    line-height: 1.25vw;
    padding: 0;
    margin: 0;
  }
  .accept-time-input {
    width: 100%;
    height: 3.403vw;
    font-size: 1.111vw;
    line-height: 1.25vw;
    margin-top: 0.694vw;
    padding: 1.042vw 2.826vw;
  }
  .accept-time-input::-webkit-outer-spin-button,
  .accept-time-input ::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
}
</style>
